/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';

/**
 * Helper that facilitate the use of the {@link Route} component
 */

/**
 * Returns a composite component where a {@link Route} component wraps the provided component
 *
 * @param {React.Component} WrappedComponent    - React component to be wrapped
 * @param {string} [extension=html]             - extension used to identify a route amongst the tree of resource URLs
 * @returns {CompositeRoute}
 */

export const withRoute = (WrappedComponent: any, extension?: string | undefined): any => {
  return class CompositeRoute extends Component {
    props: any;
    render(): JSX.Element {
      const routePath = this.props.cqPath;
      if (!routePath) {
        return <WrappedComponent {...this.props} />;
      }

      extension = extension || 'html';

      // Context path + route path + extension
      return (
        <Route
          key={routePath}
          exact
          path={'(.*)' + routePath + '(.' + extension + ')?'}
          render={(routeProps: RouteComponentProps<any>): JSX.Element => {
            return <WrappedComponent {...this.props} {...routeProps} />;
          }}
        />
      );
    }
  };
};
